import * as yup from "yup";


export const discordSchema = yup.object().shape({

  discordUserName: yup.string()
    .lowercase()
    .min(2, "Username must be at least 2 characters long")
    .max(32, "Username must be at most 32 characters long")
    .matches(/^(?!.*\.\.)(?!.*__)[a-z0-9._]+$/, { message: "Username can only contain lowercase letters, numbers, underscores, and periods, and cannot have consecutive periods or underscores." })
    .matches(/^(?![0-9._]*$)[a-z0-9._]+$/, { message: "Username must contain at least one letter." })
    .matches(/^(?!.*\b(Discord|discordstaff|systemmessages)\b)[a-z0-9._]+$/, { message: "Username cannot impersonate Discord or its staff." }),
});